<template>
	<div class="packaging-view">
		<div class="body" v-show="value.length > 0">
			<div class="header">
				<div class="label">Produkt</div>
				<div class="qty" title="Levering">Antal</div>
				<div class="unit"></div>
				<div class="price" title="Pris">Enhedspris</div>
				<div class="adjust" title="Justering">Justering</div>
				<div class="vat" title="Moms">Moms</div>
				<div class="total" title="Total">Total</div>
				<div></div>
			</div>
			<div class="row" v-for="(line, i) in value" v-bind:key="i">
				<div class="label"><lazy-entity-select-view url="/products/search/" v-model="value[i]" :lbl.sync="line.label" :map="productMap" :labelMap="productLabel" :descMap="productDesc" :validator="productValidator" :clearMap="clearProduct" :lazy="true" :highlight="_alt_price_ids" /></div>
				<div class="qty"><simple-number-view @click.stop="focus" v-model="line.qty" @focus="focusLine = i" @blur="focusLine = null" /></div>
				<div class="unit"><input @click="focus" type="text" v-model="line.unit"></div>
				<div class="price"><simple-number-view @click="focus" v-model="line.price" /></div>
				<div class="adjust"><simple-number-view @click="focus" v-model="line.adjustment" /></div>
				<div class="vat"><simple-number-view @click="focus" v-model="line.vat" /></div>
				<div class="total">{{ $_OrderMixin_normalizeLine(line).total | number }}</div>
				<div class="btn" @click="remove(i)" style="text-align: right;">X</div>
			</div>
			<div class="row" v-for="(line, i) in _extras" v-bind:key="i">
				<div class="label" style="line-height: 30px;">{{ line.label }}</div>
				<div class="qty" style="line-height: 30px;">{{ line.percent | number }}</div>
				<div class="unit" style="line-height: 30px;">%</div>
				<div class="price" style="line-height: 30px;">{{ line.base | number }}</div>
				<div class="adjust"></div>
				<div class="vat" style="line-height: 30px;">0%</div>
				<div class="total">{{ (line.percent / 100.) * line.base | number }}</div>
				<div class="btn"></div>
			</div>
			<div class="row">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div class="sum-title line">Rabat</div>
				<div class="total line">{{ _discount | number }}</div>
				<div></div>
			</div>
			<div class="row">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div class="sum-title">Tillæg</div>
				<div class="total">{{ _extra | number }}</div>
				<div></div>
			</div>
			<div class="row">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div class="sum-title line">Total</div>
				<div class="total line">{{ _total | number }}</div>
				<div></div>
			</div>
			<div class="row">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div class="sum-title">Moms</div>
				<div class="total">{{ _vat | number }}</div>
				<div></div>
			</div>
		</div>
		<div class="btn" @click="add">Tilføj produkt</div>
		<div v-if="_combinable" class="btn" @click="combine">Kombiner</div>
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView';
	import OrderMixin from '../../mixins/OrderMixin';

	export default {
		mixins: [ OrderMixin ],
		data() {
			return {
				focusLine: null,
				packaging: [], 
				units: []
			};
		},
		props: {
			hours: {
				type: Array,
				default: () => []
			},
			value: {
				type: Array,
				default() {
					return [];
				}
			},
			altPrices: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		methods: {
			addHours() {
				
			},
			combine() {
				//
				this.$emit('input', this._combined);
			},
			focus(e) {
				e.target.select();

				// Popup
				const self = this;

				if (this.focusLine !== null && this.hours.length > 0) {
					let actions = [];

					for (const hr of this._hours) {
						if (hr === null) {
							actions.push(null);
							continue;
						}

						actions.push({
							label: hr.label,
							action: (function () {
								const h = hr.hours;
								const ln = self.focusLine;

								return function () {
									var value = Array.from(self.value);
									value[ln].qty = parseFloat(h);
									self.$emit('input', value);
								};
							})(),
							enabled: hr.hours > 0
						});
					}

					this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: e.target,
					align: 'left',
					actions: actions
				});
				}
			},
			add() {
				

				this.value.push({
					product_id: null,
					label: null,
					qty: 1,
					unit: 'stk',
					price: '',
					adjustment: '',
					vat: '25%',
					sku: null
				});
			},
			remove(idx) {
				var value = Array.from(this.value);

				value.splice(idx, 1);

				this.$emit('input', value);
			},
			getPrice(obj) {
				for (var i = 0; i < this.altPrices.length; ++i) {
					if (this.altPrices[i].product_id == obj.id) return this.altPrices[i].price;
				}

				return obj.price;
			},
			productMap(obj) {
				

				return {
					product_id: obj.id,
					label: obj.alt_label !== null && obj.alt_label != '' ? obj.alt_label : obj.label,
					desc: obj.label,
					price: this.getPrice(obj),
					unit: this._units[obj.unit].label,
					sku: obj.sku,
					vat: obj.vat,
					extra: obj._embedded.product_group.extra ? {
						label: obj._embedded.product_group.extra_label,
						percent: obj._embedded.product_group.extra_multiplier,
					} : null
				};
			},
			productLabel(obj) {
				return obj.label;
			},
			productDesc(obj) {
				return obj.desc;
			},
			productValidator(obj) {
				return obj.product_id !== null;
			},
			clearProduct(obj) {
				return {
					product_id: null
				};
			}
		},
		computed: {
			_hours() {
				let r = [];
				let total = 0;

				for (const hours of this.hours) {
					r.push(hours);
					total += hours.hours;
				}

				if (this.hours.length > 0) {
					r.push(null);

					r.push({
						label: `${this.$options.filters.number(total)} timer (Alle)`,
						hours: total
					});
				}

				return r;
			},
			_combined() {
				let r = [];
				const test = ['adjustment', 'desc', 'extra', 'label', 'price', 'product_id', 'sku', 'unit', 'vat'];

				from: for (const fromLine of this.value) {
					to: for (const toLine of r) {
						for (const t of test) {
							if (fromLine[t] != toLine[t]) continue to;
						} 

						toLine.qty += fromLine.qty;
						continue from;
					}

					// Not found
					r.push(Object.assign({}, fromLine));
				}

				return r;
			},
			_combinable() {
				return JSON.stringify(this._combined) != JSON.stringify(this.value);
			},
			_alt_price_ids() {
				return this.altPrices.map((item) => {
					return item.product_id;
				});
			},
			_units() {
				var r = {};

				for (var i = 0; i < this.units.length; ++i) {
					r[this.units[i].name] = this.units[i];
				}

				return r;
			},
			_total() {
				return this.$_OrderMixin_total(this.value);
			},
			_vat() {
				return this.$_OrderMixin_vat(this.value);
			},
			_discount() {
				return this.$_OrderMixin_discount(this.value);
			},
			_extra() {
				return this.$_OrderMixin_extra(this.value);
			},
			_extras() {
				return this.$_OrderMixin_extras(this.value);
			}
		},
		created() {
			var self = this;

			this.axios
				.get('/products/units/')
				.then(function (r) {
					self.units = r.data._items;
				});
		}
	}
</script>

<style lang="scss" scoped>
	.packaging-view {
		& > .body {
			display: grid;
			grid-template-rows: 20px;
			row-gap: 5px;
			margin-bottom: 20px;

			& > .header, & > .row {
				display: grid;
				grid-template-columns: 5fr 2fr 3fr 4fr 4fr 2fr 4fr 20px;

				& > div {
					line-height: 20px;
					font-size: 12px;
					text-align: center;
					padding-left: 5px;

					&.unit {
						text-align: left;
					}

					&.price, &.total, &.adjust, &.vat {
						text-align: right;
					}

					&.total {
						line-height: 30px;
					}

					&:first-child {
						text-align: left;
						padding-left: 0;
					}
				}

				& > .btn {
					background-color: transparent ! important;
					line-height: 30px;
					margin: 0;
				}
			}

			& > .header {
				& > div {
					font-weight: bold;
				}
			}

			& > .row {
				& > div.sum-title {
					line-height: 30px;
					text-align: left;
				}

				& > div.line {
					border-top: 1px solid white;
					padding-top: 5px;
				}

				& > div {
					& > input {
						width: 100%;
					
						text-align: center;
						background-color: #202127;
						color: white;
						line-height: 20px;
						font-size: 12px;
						padding: 5px;
					}

					&.unit > input {
						text-align: left;
					}

					&.price > input, &.adjust > input, &.vat > input {
						text-align: right;
					}

					&.label {
						width: 100%;

						&::v-deep .entity-select-view {
							height: 100%;

							& > input {
								font-size: 12px;
							}
						}
					}
				}
			}			
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>